const TOKEN_KEY = 'arcology_auth_token';
const USER_KEY = 'arcology_user';
const KEYCLOAK_TOKEN_KEY = 'arcology_keycloak_token';

// API base URL - use empty string for relative URLs in production
const API_URL = process.env.NODE_ENV === 'production'
  ? (process.env.REACT_APP_API_URL || '')
  : (process.env.REACT_APP_API_URL || 'http://localhost:3001');

/**
 * SAVE auth token to localStorage
 */
export function saveToken(token) {
  localStorage.setItem(TOKEN_KEY, token);
}

/**
 * GET auth token from localStorage
 */
export function getToken() {
  return localStorage.getItem(TOKEN_KEY);
}

/**
 * REMOVE auth token from localStorage
 */
export function removeToken() {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(USER_KEY);
  localStorage.removeItem(KEYCLOAK_TOKEN_KEY);
}

/**
 * SAVE user data to localStorage
 */
export function saveUser(user) {
  localStorage.setItem(USER_KEY, JSON.stringify(user));
}

/**
 * GET user data from localStorage
 */
export function getUser() {
  const userData = localStorage.getItem(USER_KEY);
  return userData ? JSON.parse(userData) : null;
}

/**
 * CHECK if user is authenticated
 */
export function isAuthenticated() {
  return !!getToken();
}

/**
 * VALIDATE Keycloak token with backend
 */
export async function validateKeycloakToken(token) {
  const response = await fetch(`${API_URL}/api/auth/login`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ token }),
  });

  const data = await response.json();

  if (!response.ok) {
    throw new Error(data.error || 'Token validation failed');
  }

  return data; // Returns { user, token } or { needsHandle: true, keycloakId }
}

/**
 * SELECT handle for Keycloak user
 */
export async function selectHandleForKeycloak(keycloakId, handle) {
  const response = await fetch(`${API_URL}/api/auth/select-handle`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ keycloakId, handle }),
  });

  const data = await response.json();

  if (!response.ok) {
    throw new Error(data.error || 'Handle selection failed');
  }

  return data; // Returns { user, token }
}

/**
 * SAVE Keycloak token to localStorage (for future token refresh)
 */
export function saveKeycloakToken(token) {
  localStorage.setItem(KEYCLOAK_TOKEN_KEY, token);
}

/**
 * GET Keycloak token from localStorage
 */
export function getKeycloakToken() {
  return localStorage.getItem(KEYCLOAK_TOKEN_KEY);
}

/**
 * REMOVE Keycloak token from localStorage
 */
export function removeKeycloakToken() {
  localStorage.removeItem(KEYCLOAK_TOKEN_KEY);
}
